module.exports = __webpack_public_path__ + "static/img/heat-treatment.dbdc5c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heat-treatment.png
// module id = g+Gj
// module chunks = 1